// Module
var code = "<a href=\"javascript:;\" class=\"text-sm sps-btn sps-btn-outline btn-color-consult-screen\"> <i class=\"fa fa-desktop\" align=\"center\"></i> <!-- ko text: _labels.CONSULT --><!-- /ko --> </a>";
// Exports
export default code;